// Lightweight CSS aurora background — replaces heavy tsparticles
function Particle() {
  return (
    <div className="aurora-bg" aria-hidden="true">
      <div className="aurora-orb aurora-orb-1"></div>
      <div className="aurora-orb aurora-orb-2"></div>
      <div className="aurora-orb aurora-orb-3"></div>
    </div>
  );
}

export default Particle;
